import HorizontalShopItem from "./HorizontalShopItem";

export default function HorizontalShopList() {
    return (<div className="mt-2 px-5 gap-2 overflow-x-scroll relative whitespace-nowrap no-scrollbar">
        <HorizontalShopItem />
        <HorizontalShopItem />
        <HorizontalShopItem />
        <HorizontalShopItem />
        <HorizontalShopItem />
        <HorizontalShopItem />
    </div>);
}